/**
 * Màu **dữ liệu** — giá trị người dùng chọn và app ghi vào cột `color` /
 * `avatarColor` / `logoColor` của kênh, nhóm và đối tác.
 *
 * Khác token giao diện ở `theme.css`: token là màu **của app** (nền, viền,
 * chip trạng thái), đổi thiết kế là đổi hết một lượt. Màu ở đây đi theo **một
 * hàng trong database**; đổi nó không làm kênh đang có màu cũ đổi theo.
 *
 * Vì thế nó không nằm trong `@theme`, nhưng cũng không được rải: bốn chỗ từng
 * gõ lại `'#4F46E5'` (mặc định của Avatar, form kênh, hộp nhóm, form đối tác),
 * nên chọn màu mặc định khác là phải tìm đủ bốn chỗ.
 */
export const MAU_DU_LIEU_MAC_DINH = '#4F46E5';
